module.exports = __webpack_public_path__ + "img/bggenie.f409e62a.png";